<div class="poll-block poll-main">

    <div *ngIf="poll; else defaultPoll" [formGroup]="pollForm">
        <div class="poll-title" >
            <input type="text" formControlName="name">
        </div>
        <div class="poll-description">
            <textarea cdkTextareaAutosize formControlName="description"></textarea>
        </div>
    </div>
    <ng-template #defaultPoll>
        <div class="poll-title" >
            Новая форма
        </div>
        <div class="poll-description">
            Описание
        </div>
    </ng-template>
</div>
<ng-container *ngIf="pollFields">
    <ng-container *ngIf="pollFields.length > 0; else widgetDefault">
        <poll-fields-widget [parentId]="poll_id" [pollFields]="pollFields"></poll-fields-widget>
    </ng-container>
    <ng-template #widgetDefault>
        <poll-fields-widget [parentId]="poll_id"></poll-fields-widget>
    </ng-template>
</ng-container>